<template>
  <div
    class="thumbnail"
    :style="{
      width: `${dimension}px`,
      height: `${dimension}px`,
      'background-image': `url(${url})`,
      'background-size': '100%',
      'background-position': 'center',
      'border-radius': `${borderRadius}px`
    }"
  >
    <div class="shade" :style="{ 'border-radius': `${borderRadius}px` }"></div>
  </div>
</template>

<style lang="scss" scoped>
.thumbnail {
  flex-shrink: 0;
  position: relative;

  .shade {
    box-shadow: inset 2px 2px 4px 0 #a6abbd, inset -2px -2px 4px 0 #fafbff;
    border: solid 1px rgba(255, 255, 255, 0.4);

    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: -1px;
  }
}
</style>

<script>
export default {
  props: {
    url: {
      type: String,
      required: true
    },
    format: {
      type: String,
      default: 'square'
    },
    size: {
      type: String,
      default: 'medium'
    }
  },
  computed: {
    dimension() {
      switch (this.size) {
        case 'x-small':
          return 24;
        case 'small':
          return 32;
        case 'large':
          return 64;
        case 'medium':
        default:
          return 48;
      }
    },
    borderRadius() {
      switch (this.format) {
        case 'square':
          return 8;
        case 'circle':
          return this.dimension;
        default:
          return 0;
      }
    }
  }
};
</script>
